import React from 'react';
import { Plus } from 'lucide-react';
import { useMutation } from '@tanstack/react-query';
import { useNavigate } from 'react-router';

import { Button } from '@epoch-ui/components/Button';
import { SurveyTemplateTypes } from 'types/survey_template.types';
import { SURVEY_TEMPLATE_EDIT_ROUTE } from 'constants/routes';

import { createSurveyTemplate } from '../../../api/createSurveyTemplate';

interface CreateTemplateButtonProps {
  className?: string;
}

export const CreateTemplateButton: React.FC<CreateTemplateButtonProps> = ({ className = '' }) => {
  const navigate = useNavigate();

  const { mutate, isPending } = useMutation({
    mutationFn: createSurveyTemplate,
    onSuccess: (data) => {
      if (data.createSurveyTemplate?.surveyTemplate?.id) {
        navigate(`${SURVEY_TEMPLATE_EDIT_ROUTE}/${data.createSurveyTemplate.surveyTemplate.id}`);
      }
    }
  });

  return (
    <Button
      size="xs"
      onClick={() =>
        mutate({
          title: '',
          description: '',
          type: SurveyTemplateTypes.FEEDBACK
        })
      }
      className={className}
      loading={isPending}
    >
      <Plus size={16} className="tw-mr-2" /> Create template
    </Button>
  );
};
